export const environment = {
  production: true,
  buildId: '3996162124024261',
  configFile: 'config.json',
};
